import React, {
  useEffect,
  useState,
} from 'react';

import filter from 'lodash/filter';
import sortBy from 'lodash/sortBy';
import values from 'lodash/values';

interface FilterItemData {
    id: string;
    name: string;
    selected: boolean;
}

export interface FilterItemProps {
    key?: string;
    data: FilterItemData[];
    name: string;
    label: string;
    value?: any;
    reset?: boolean;
    sort?: string;
    onChange?: (key: string, value: any) => void;
}

const FilterItem: React.FC<FilterItemProps> = ({ data, name, label, value, sort = null, reset = false, onChange }) => {
    const [val, setVal] = useState(value);

    useEffect(() => {
        setVal(value);
    }, [value]);

    useEffect(() => {
        if (reset && value !== val) {
            setVal(value);
        }
    }, [reset]);

    const handleFilterChange = e => {
        const inputVal = e.currentTarget.value;
        setVal(inputVal);

        if (onChange) {
            onChange(name, inputVal);
        }
    };

    const getData = () => {
        if (sort) {
            const list = sortBy(filter(values(data), o => o.id !== 'all'), [sort]);
            const all = filter(values(data), o => o.id === 'all');
            return all.length > 0  ? [...all, ...list] : list;
        }

        return values(data);
    };

    return (
        <div className="sl__filter__group">
            <label>{label}</label>
            <select name={name} value={val} onChange={handleFilterChange}>
                {getData().map(row => (
                    <option key={row.id} value={row.sales_rep_id || row.id}>{row.name}</option>
                ))}
            </select>
        </div>
    );
};

export default FilterItem;



// WEBPACK FOOTER //
// ./src/sections/SmartList/FilterItem.tsx